module.exports = __webpack_public_path__ + "static/media/cannabis.980b90fe.svg";